<forge-card fxFlex="auto" fxLayout="column" fxLayoutAlign="space-between start" [formGroup]="noteForm"
  telemetry="Card-Note">
  <div id="body">
    <div fxFlexFill fxLayout="row" fxLayoutAlign="space-between center">
      <labeled-field label="Created By">
        <span>{{model.CreatedBy}}</span>
      </labeled-field>

      <labeled-field label="Created On">
        <span>{{model.CreatedDate | date}}</span>
      </labeled-field>

      @if (!viewOnly) {
        <command [command]="deleteCommand" telemetry="Submission-Delete-Note"></command>
      }

    </div>

    @if (!hideSubject) {
      <div>
        <lgd-text controlName="subject" label="Subject">
        </lgd-text>
      </div>
    }

    <div>
      <lgd-text controlName="description" label="Description">
      </lgd-text>
    </div>
  </div>
</forge-card>